import React from 'react';

import { MAX_FILE_UPLOAD_PIXEL_SIZE } from '@repo/editor/src/global/constants';
import { fireToast } from '@repo/ui/components/Toast';

export const rasterImageTypes = ['image/png', 'image/jpeg'];

export const getValidDataTransferItemFromDragEvent = (
  event: React.DragEvent
): DataTransferItem | null => {
  if (!event.dataTransfer.items) {
    return null;
  }

  const items = Array.from(event.dataTransfer.items);

  const isValid =
    items.length === 1 &&
    items[0].kind === 'file' &&
    rasterImageTypes.includes(items[0].type);

  if (!isValid) {
    return null;
  }

  return items[0];
};

export const getImageDimensions = (
  url: string
): Promise<{ width: number; height: number }> => {
  return new Promise<{ width: number; height: number }>((resolve, reject) => {
    const image = new Image();
    image.src = url;

    image.onload = (): void => {
      const height = image.naturalHeight;
      const width = image.naturalWidth;
      resolve({ width, height });
    };

    image.onerror = reject;
  });
};

export const getImageDimensionsFromFile = async (
  file: File
): Promise<{ width: number; height: number }> => {
  const objectUrl = URL.createObjectURL(file);
  const dimensions = await getImageDimensions(objectUrl);
  URL.revokeObjectURL(objectUrl);

  return dimensions;
};

export const hasValidDimensions = async (file: File): Promise<boolean> => {
  const objectUrl = URL.createObjectURL(file);
  const dimensions = await getImageDimensions(objectUrl);
  URL.revokeObjectURL(objectUrl);

  if (MAX_FILE_UPLOAD_PIXEL_SIZE ** 2 < dimensions.width * dimensions.height) {
    fireToast({
      label: `Uploaded image dimensions cannot exceed ${MAX_FILE_UPLOAD_PIXEL_SIZE}x${MAX_FILE_UPLOAD_PIXEL_SIZE} pixels`,
      error: true,
    });
    return false;
  }
  return true;
};
